/**
 * @generated SignedSource<<e8aeb476a967edaec3047682f885501e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HistoryTab_module$data = {
  readonly flow: {
    readonly activities: {
      readonly nodes: ReadonlyArray<{
        readonly createdAt: Date | null | undefined;
        readonly gwtUser: {
          readonly firstName: string;
          readonly lastName: string;
        } | null | undefined;
        readonly linkLocation: string | null | undefined;
        readonly object: string;
        readonly rowId: UUID;
        readonly verb: string;
      }>;
    };
  } | null | undefined;
  readonly " $fragmentType": "HistoryTab_module";
};
export type HistoryTab_module$key = {
  readonly " $data"?: HistoryTab_module$data;
  readonly " $fragmentSpreads": FragmentRefs<"HistoryTab_module">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HistoryTab_module",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": "CREATED_AT_DESC"
            }
          ],
          "concreteType": "ActivitiesConnection",
          "kind": "LinkedField",
          "name": "activities",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Activity",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "verb",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "linkLocation",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "object",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GwtUser",
                  "kind": "LinkedField",
                  "name": "gwtUser",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "activities(orderBy:\"CREATED_AT_DESC\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Module",
  "abstractKey": null
};

(node as any).hash = "74bcc5279ab95535dcc6acd4ff0a6c09";

export default node;
